import { connect } from 'react-redux';
import { getSection } from 'website/website.selectors';
import Services from 'components/Services';

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return getSection(state, "SERVICES")[0].data;
}

export default connect(mapStateToProps, mapDispatchToProps)(Services);


// WEBPACK FOOTER //
// ./src/containers/Services.container.js